"use-strict";

import constants from "./standingsConstants";

export default {
  setAllStandings: (payload) => ({
    type: constants.SET_ALL_STANDINGS,
    payload,
  }),
  clearAllStandings: () => ({
    type: constants.CLEAR_ALL_STANDINGS,
  }),
};
